import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { LANGUAGES } from '../utils/localization/localization';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import Stack from '@mui/material/Stack';

// Custom styled switch for language selection
const LanguageSwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(6px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(22px)',
      '& .MuiSwitch-thumb:before': {
        content: "'FR'",
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 'bold',
        fontSize: '12px',
        color: '#1976d2'
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be'
      }
    }
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? '#003892' : '#ffffff',
    width: 32,
    height: 32,
    '&:before': {
      content: "'EN'",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: 'bold',
      fontSize: '12px',
      color: '#1976d2'
    }
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
    borderRadius: 20 / 2
  }
}));

/**
 * Language slide switch component that toggles between EN and FR
 */
const LanguageSlideSwitch = () => {
  const { currentLanguage, changeLanguage } = useLanguage();
  const [checked, setChecked] = React.useState(currentLanguage === LANGUAGES.FR);

  // Update local state when language context changes
  React.useEffect(() => {
    setChecked(currentLanguage === LANGUAGES.FR);
  }, [currentLanguage]);

  const handleChange = (event) => {
    const isChecked = event.target.checked;
    setChecked(isChecked); // Update local state immediately
    const newLanguage = isChecked ? LANGUAGES.FR : LANGUAGES.EN;
    changeLanguage(newLanguage);
  };

  return (
    <FormGroup sx={{ mr: 2 }}>
      <Stack direction="row" spacing={1} alignItems="center">
        <LanguageSwitch
          checked={checked}
          onChange={handleChange}
          inputProps={{ 'aria-label': 'language switch' }}
        />
      </Stack>
    </FormGroup>
  );
};

export default LanguageSlideSwitch;
